/*
 * Copyright (c) 2026 Centrica.  All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * Date: 2026-09-10
 */

import { Injectable } from '@angular/core';
import { API_CONFIG, BaseCrudService } from '@nebula-shared/data-access';
export interface Currency {
  id: string;
  codigo: string;
  descripcion: string;
  estadoMoneda: string;
}

@Injectable({ providedIn: 'root' })
export class CurrencyService extends BaseCrudService<Currency> {
  constructor() {
    super();
    const config = API_CONFIG.accounting;
    this.setBaseUrl(`${config.baseUrl}${config.endpoints.monedas}`);
  }
  /**
   * Ruta del page-response de monedas, la que consulta la ventana de busqueda de maestros con el
   * filtro fijo de monedas activas; el servidor pagina, busca y ordena.
   *
   * @returns la ruta completa del page-response de monedas
   */
  get rutaDePageResponse(): string {
    return `${this.baseUrl}/page-response`;
  }
}
